<template>
  <status-chip
    v-if="orderHasDeliveryStatus"
    :avatar-color="`${orderDeliveryStatus.Color} darken-2`"
    :color="orderDeliveryStatus.Color"
    :dense="dense"
    :icon="orderDeliveryStatus.Icon"
    :label="orderDeliveryStatus.Label"
    :min-width="chipMinWidth"
    :tooltip="tooltipText"
    tooltip-position="right"
    v-on="$listeners"
  />
</template>

<script>

import moment from 'moment/moment'
import StatusChip from '@/components/common/StatusChip.vue'
import OrderTypeTime from '@/mixins/orders/orderTypeTime'

export default {
  name      : 'OrderDeliveryStatusChip',
  components: {StatusChip},
  directives: {},
  mixins    : [OrderTypeTime],
  props     : {
    order: {
      type   : Object,
      default: undefined
    },
    minWidth: {
      type   : [Number, String],
      default: 125
    },
    dense: {
      type   : Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    orderDeliveryStatus() {
      if (this.order?.DeliveryStaffDelivered) return this.$t('Delivery.DeliveryOrderStatus.Delivered')
      if (this.order?.DeliveryStaffReceived) return this.$t('Delivery.DeliveryOrderStatus.Received')
      if (this.order?.DeliveryStaffAccepted) return this.$t('Delivery.DeliveryOrderStatus.Accepted')
      if (this.order?.DeliveryStaffAdded) return this.$t('Delivery.DeliveryOrderStatus.Added')

      return null
    },

    orderHasDeliveryStatus() {
      return this.order && this.order?.DeliveryStaffDelivered || this.order?.DeliveryStaffReceived || this.order?.DeliveryStaffAccepted || this.order?.DeliveryStaffAdded
    },

    tooltipText() {
      return this.order?.DeliveryStaffFirstname
        ? `<div class="text-center">
             <h3><strong>${this.$tc('Delivery.Title', 1)}</strong></h3>
             <h4>${this.order.DeliveryStaffFirstname} ${this.order.DeliveryStaffLastname}</h4>
           </div>
           <div class="mt-4 text-caption text-no-wrap">
           ` +
          (this.order?.DeliveryStaffAdded ? `<div><div style="width: 78px;" class="font-weight-bold d-inline-block">${this.$t('Delivery.DeliveryOrderStatus.Added.Label')}</div>: ${this.order?.DeliveryStaffAdded} ${this.orderTimeElapsed.DeliveryStaffAdded}</div>` : '') +
          (this.order?.DeliveryStaffAccepted ? `<div><div style="width: 78px;" class="font-weight-bold d-inline-block">${this.$t('Delivery.DeliveryOrderStatus.Accepted.Label')}</div>: ${this.order?.DeliveryStaffAccepted} ${this.orderTimeElapsed.DeliveryStaffAccepted}</div>` : '') +
          (this.order?.DeliveryStaffReceived ? `<div><div style="width: 78px;" class="font-weight-bold d-inline-block">${this.$t('Delivery.DeliveryOrderStatus.Received.Label')}</div>: ${this.order?.DeliveryStaffReceived} ${this.orderTimeElapsed.DeliveryStaffReceived}</div>` : '') +
          (this.order?.DeliveryStaffDelivered ? `<div><div style="width: 78px;" class="font-weight-bold d-inline-block">${this.$t('Delivery.DeliveryOrderStatus.Delivered.Label')}</div>: ${this.order?.DeliveryStaffDelivered} ${this.orderTimeElapsed.DeliveryStaffDelivered}</div>` : '') +
          `
           </div>
          `
        : ''
    },

    orderTimeElapsed() {
      if (!this.order) return ''

      const orderDate = moment(this.order.DateAdded + ' ' + this.order.TimeAdded, 'DD-MM-YYYY HH:mm:ss')
      const deliveryAddedDate = moment(this.order?.DeliveryStaffAdded, 'DD/MM/YYYY HH:mm')
      const deliveryAcceptedDate = moment(this.order?.DeliveryStaffAccepted, 'DD/MM/YYYY HH:mm')
      const deliveryReceivedDate = moment(this.order?.DeliveryStaffReceived, 'DD/MM/YYYY HH:mm')
      const deliveryDeliveredDate = moment(this.order?.DeliveryStaffDelivered, 'DD/MM/YYYY HH:mm')

      const deliveryStaffAddedMinutesDiff = this.convertMinutesToDisplayString(deliveryAddedDate.diff(orderDate, 'minutes') || 1)
      const deliveryStaffAcceptedMinutesDiff = this.convertMinutesToDisplayString(deliveryAcceptedDate.diff(deliveryAddedDate, 'minutes') || 1)
      const deliveryStaffReceivedMinutesDiff = this.convertMinutesToDisplayString(deliveryReceivedDate.diff(deliveryAcceptedDate, 'minutes') || 1)
      const deliveryStaffDeliveredMinutesDiff = this.convertMinutesToDisplayString(deliveryDeliveredDate.diff(deliveryReceivedDate, 'minutes') || 1)

      return {
        DeliveryStaffAdded    : deliveryStaffAddedMinutesDiff ? `(${deliveryStaffAddedMinutesDiff})` : '',
        DeliveryStaffAccepted : deliveryStaffAcceptedMinutesDiff ? `(${deliveryStaffAcceptedMinutesDiff})` : '',
        DeliveryStaffReceived : deliveryStaffReceivedMinutesDiff ? `(${deliveryStaffReceivedMinutesDiff})` : '',
        DeliveryStaffDelivered: deliveryStaffDeliveredMinutesDiff ? `(${deliveryStaffDeliveredMinutesDiff})` : ''
      }
    },

    chipMinWidth() {
      return this.minWidth.toString().replaceAll('px', '')
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {}
}
</script>

<style scoped>

</style>
